import { useMemo } from "react";

import {
  GuideTourHost as PackageGuideTourHost,
  GUIDE_TOUR_TARGET_SEARCH_INTERVAL_MS,
  GUIDE_TOUR_TARGET_SEARCH_TIMEOUT_MS,
} from "../../packages/guide-tour/src";
import { useAuthStore } from "../stores/authStore";

import { GUIDE_TOUR_CONFIG, getGuideTourStepsForModule } from "./guideTourConfig";
import { getGuideTourPersistence } from "./guideTourStorage";
import type { GuideTourModule } from "./types";

interface GuideTourHostProps {
  targetSearchIntervalMs?: number;
  targetSearchTimeoutMs?: number;
}

export function GuideTourHost({
  targetSearchIntervalMs = GUIDE_TOUR_TARGET_SEARCH_INTERVAL_MS,
  targetSearchTimeoutMs = GUIDE_TOUR_TARGET_SEARCH_TIMEOUT_MS,
}: GuideTourHostProps) {
  const user = useAuthStore((state) => state.user);
  const persistence = useMemo(() => getGuideTourPersistence(user), [user]);

  return (
    <PackageGuideTourHost
      getModuleLabel={(module) => GUIDE_TOUR_CONFIG[module].label}
      persistence={persistence}
      resolveSteps={(module) => getGuideTourStepsForModule(user, module)}
      targetSearchIntervalMs={targetSearchIntervalMs}
      targetSearchTimeoutMs={targetSearchTimeoutMs}
    />
  );
}
